export default {
      id: "consulter-usage",
      viewBox: "0 0 50 50",
      url: "../dist/images/" + "sprite.svg#consulter-usage",
      toString: function () {
        return this.url;
      }
    }